// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3EHog","loaderOuter":"PageOverlayLoader_loaderOuter__2zbGT"};